import React, { PropsWithChildren } from "react";
import cn from "classnames";
import IconButton from "../controls/IconButton";

export interface FormArrayItemProps {
  className?: string;
  idPrefix?: string;
  index: number;
  remove?: null | ((index: number) => void);
}

const FormArrayItem = (props: PropsWithChildren<FormArrayItemProps>): JSX.Element => {
  const { className, children, idPrefix, index, remove } = props;
  const trashButtonId = idPrefix ? `btn_${idPrefix}_${index}_trash` : undefined;
  return (
    <div className={cn("FormArrayItem", className)}>
      {children}
      {remove && (
        <div className="u-text-right">
          <IconButton
            className="FormArrayItem-remove"
            id={trashButtonId}
            onClick={() => remove(index)}
            symbolId="trash"
          />
        </div>
      )}
    </div>
  )
}

export default FormArrayItem;
